export default __webpack_public_path__ + "static/media/B0007.4a242552.png";